import React from 'react'

const LanguageContext = React.createContext()
const LanguageConsumer = LanguageContext.Consumer

function LanguageProvider(props) {
  return <LanguageContext.Provider value={props.value}>{props.children}</LanguageContext.Provider>
}

const useLanguage = () => {
  return React.useContext(LanguageContext)
}

export default LanguageContext
export { LanguageProvider, LanguageConsumer, useLanguage }
